/* tslint:disable */
/* eslint-disable */
/**
 * Joule Conductor Cloud
 * This specification document describes the Joule Technologies Application Programming Interface  (API). The endpoints, message formats and status codes are explained in this document. ## Communication  ### Base URI  The base Uniform Resource Identifier (URI) is: https://user-api.joule-cloud.com/v2 This URI is the prefix for all endpoints described in this document. ### Body format  The endpoints of the API expecting a body must be in JavaScript Object Notation (JSON) format.  Response bodies from the endpoints also adhere to this standard, unless otherwise stated.  Responses will include a Content-Type header indicating the ‘application/json’ type. An invalid  or missing body will result in a 400-status code accompanied by an error code to specify the  nature of the error. ### Security The API uses HTTPS as the underlying protocol to transfer data. The server hosts a certificate  to set up a secure connection using Transport Layer Security (TLS) version 1.2. The authenticity  of the server certificate is verifiable by the client using publicly available sources.  #### Authentication and authorization  The API should only be called by legitimate users with the correct access rights. The API uses  the Open Authorization 2.0 (OAuth) standard to achieve this. Every request to the API should  include a bearer access token in the JSON Web Token (JWT) format in the Authorization header.  The header should be formatted such as in the example below.  ```   {“Authorization”: “Bearer <JWT>”}  ``` The JWT must be acquired from one of the following identity providers:   * joule-technologies.eu.auth0.com    * inventum-app.eu.auth0.com    * joule-app.eu.auth0.com   For help regarding gaining an access token you can find the docs for Auth0  [here](https://auth0.com/docs/secure/tokens/access-tokens/get-access-tokens). The JWT must be intended for one of the following audiences:    * https://user-api.joule-cloud.com   If the authorization header does not match the requirements stated above the API will respond  with a 401-status code accompanied by an error code to specify the nature of the error.  ### Timeout The API specifies a maximum amount of time between a request and the response to avoid blocking  either side. The general timeout that has been set for each endpoint is 3000 milliseconds.  This timeout is used unless otherwise stated in the respective endpoint documentation.  If the server is unable to respond within this maximum time, the response contains a 504-status  code. The client may retry the request. The time out for a stream to be open is 1800 seconds.  If the stream is still open passed the experitation the server will close the stream. ### Rate limits  No rate limit is currently imposed. ### Diagnostics response  The diagnostics response provides the caller of the API with more information in case of a  failed request. This information can be used for debugging and recovery/retrying purposes.  The diagnostics response is always included under the “diagnostics” key if the response  has a body. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Permission = {
    DeleteAnyResourceAccount: 'Delete_AnyResource_Account',
    DeleteAnyResourceAdministration: 'Delete_AnyResource_Administration',
    DeleteAnyResourceConfAmbientOffset: 'Delete_AnyResource_Conf_AmbientOffset',
    DeleteAnyResourceConfBoilerControlMode: 'Delete_AnyResource_Conf_BoilerControlMode',
    DeleteAnyResourceConfClimateMode: 'Delete_AnyResource_Conf_ClimateMode',
    DeleteAnyResourceConfDeviceInfo: 'Delete_AnyResource_Conf_DeviceInfo',
    DeleteAnyResourceConfDeviceReset: 'Delete_AnyResource_Conf_DeviceReset',
    DeleteAnyResourceConfDhwBoost: 'Delete_AnyResource_Conf_DhwBoost',
    DeleteAnyResourceConfDhwPreferences: 'Delete_AnyResource_Conf_DhwPreferences',
    DeleteAnyResourceConfDisplayBrightness: 'Delete_AnyResource_Conf_DisplayBrightness',
    DeleteAnyResourceConfFilterState: 'Delete_AnyResource_Conf_FilterState',
    DeleteAnyResourceConfFlameState: 'Delete_AnyResource_Conf_FlameState',
    DeleteAnyResourceConfHeatPumpSetup: 'Delete_AnyResource_Conf_HeatPumpSetup',
    DeleteAnyResourceConfLegionella: 'Delete_AnyResource_Conf_Legionella',
    DeleteAnyResourceConfPreheatSetpoint: 'Delete_AnyResource_Conf_PreheatSetpoint',
    DeleteAnyResourceConfRemoteLogging: 'Delete_AnyResource_Conf_RemoteLogging',
    DeleteAnyResourceConfRoomSetpoint: 'Delete_AnyResource_Conf_RoomSetpoint',
    DeleteAnyResourceConfSettings: 'Delete_AnyResource_Conf_Settings',
    DeleteAnyResourceConfSharingPolicy: 'Delete_AnyResource_Conf_SharingPolicy',
    DeleteAnyResourceConfVentilation: 'Delete_AnyResource_Conf_Ventilation',
    DeleteAnyResourceConfWeekschedule: 'Delete_AnyResource_Conf_Weekschedule',
    DeleteAnyResourceConfWeekscheduleState: 'Delete_AnyResource_Conf_WeekscheduleState',
    DeleteAnyResourceDevice: 'Delete_AnyResource_Device',
    DeleteAnyResourceDeviceAnalytics: 'Delete_AnyResource_DeviceAnalytics',
    DeleteAnyResourceFirmware: 'Delete_AnyResource_Firmware',
    DeleteAnyResourceHistory: 'Delete_AnyResource_History',
    DeleteAnyResourceManufacturing: 'Delete_AnyResource_Manufacturing',
    DeleteAnyResourceMetrics: 'Delete_AnyResource_Metrics',
    DeleteAnyResourceRoles: 'Delete_AnyResource_Roles',
    DeleteAnyResourceSystem: 'Delete_AnyResource_System',
    DeleteAnyResourceTranslation: 'Delete_AnyResource_Translation',
    DeleteAnyResourceUser: 'Delete_AnyResource_User',
    DeleteDirectLinkAccount: 'Delete_DirectLink_Account',
    DeleteDirectLinkAdministration: 'Delete_DirectLink_Administration',
    DeleteDirectLinkConfAmbientOffset: 'Delete_DirectLink_Conf_AmbientOffset',
    DeleteDirectLinkConfBoilerControlMode: 'Delete_DirectLink_Conf_BoilerControlMode',
    DeleteDirectLinkConfClimateMode: 'Delete_DirectLink_Conf_ClimateMode',
    DeleteDirectLinkConfDeviceInfo: 'Delete_DirectLink_Conf_DeviceInfo',
    DeleteDirectLinkConfDeviceReset: 'Delete_DirectLink_Conf_DeviceReset',
    DeleteDirectLinkConfDhwBoost: 'Delete_DirectLink_Conf_DhwBoost',
    DeleteDirectLinkConfDhwPreferences: 'Delete_DirectLink_Conf_DhwPreferences',
    DeleteDirectLinkConfDisplayBrightness: 'Delete_DirectLink_Conf_DisplayBrightness',
    DeleteDirectLinkConfFilterState: 'Delete_DirectLink_Conf_FilterState',
    DeleteDirectLinkConfFlameState: 'Delete_DirectLink_Conf_FlameState',
    DeleteDirectLinkConfHeatPumpSetup: 'Delete_DirectLink_Conf_HeatPumpSetup',
    DeleteDirectLinkConfLegionella: 'Delete_DirectLink_Conf_Legionella',
    DeleteDirectLinkConfPreheatSetpoint: 'Delete_DirectLink_Conf_PreheatSetpoint',
    DeleteDirectLinkConfRemoteLogging: 'Delete_DirectLink_Conf_RemoteLogging',
    DeleteDirectLinkConfRoomSetpoint: 'Delete_DirectLink_Conf_RoomSetpoint',
    DeleteDirectLinkConfSettings: 'Delete_DirectLink_Conf_Settings',
    DeleteDirectLinkConfSharingPolicy: 'Delete_DirectLink_Conf_SharingPolicy',
    DeleteDirectLinkConfVentilation: 'Delete_DirectLink_Conf_Ventilation',
    DeleteDirectLinkConfWeekschedule: 'Delete_DirectLink_Conf_Weekschedule',
    DeleteDirectLinkConfWeekscheduleState: 'Delete_DirectLink_Conf_WeekscheduleState',
    DeleteDirectLinkDevice: 'Delete_DirectLink_Device',
    DeleteDirectLinkDeviceAnalytics: 'Delete_DirectLink_DeviceAnalytics',
    DeleteDirectLinkFirmware: 'Delete_DirectLink_Firmware',
    DeleteDirectLinkHistory: 'Delete_DirectLink_History',
    DeleteDirectLinkManufacturing: 'Delete_DirectLink_Manufacturing',
    DeleteDirectLinkMetrics: 'Delete_DirectLink_Metrics',
    DeleteDirectLinkRoles: 'Delete_DirectLink_Roles',
    DeleteDirectLinkSystem: 'Delete_DirectLink_System',
    DeleteDirectLinkTranslation: 'Delete_DirectLink_Translation',
    DeleteDirectLinkUser: 'Delete_DirectLink_User',
    DeleteIndirectLinkAccount: 'Delete_IndirectLink_Account',
    DeleteIndirectLinkAdministration: 'Delete_IndirectLink_Administration',
    DeleteIndirectLinkConfAmbientOffset: 'Delete_IndirectLink_Conf_AmbientOffset',
    DeleteIndirectLinkConfBoilerControlMode: 'Delete_IndirectLink_Conf_BoilerControlMode',
    DeleteIndirectLinkConfClimateMode: 'Delete_IndirectLink_Conf_ClimateMode',
    DeleteIndirectLinkConfDeviceInfo: 'Delete_IndirectLink_Conf_DeviceInfo',
    DeleteIndirectLinkConfDeviceReset: 'Delete_IndirectLink_Conf_DeviceReset',
    DeleteIndirectLinkConfDhwBoost: 'Delete_IndirectLink_Conf_DhwBoost',
    DeleteIndirectLinkConfDhwPreferences: 'Delete_IndirectLink_Conf_DhwPreferences',
    DeleteIndirectLinkConfDisplayBrightness: 'Delete_IndirectLink_Conf_DisplayBrightness',
    DeleteIndirectLinkConfFilterState: 'Delete_IndirectLink_Conf_FilterState',
    DeleteIndirectLinkConfFlameState: 'Delete_IndirectLink_Conf_FlameState',
    DeleteIndirectLinkConfHeatPumpSetup: 'Delete_IndirectLink_Conf_HeatPumpSetup',
    DeleteIndirectLinkConfLegionella: 'Delete_IndirectLink_Conf_Legionella',
    DeleteIndirectLinkConfPreheatSetpoint: 'Delete_IndirectLink_Conf_PreheatSetpoint',
    DeleteIndirectLinkConfRemoteLogging: 'Delete_IndirectLink_Conf_RemoteLogging',
    DeleteIndirectLinkConfRoomSetpoint: 'Delete_IndirectLink_Conf_RoomSetpoint',
    DeleteIndirectLinkConfSettings: 'Delete_IndirectLink_Conf_Settings',
    DeleteIndirectLinkConfSharingPolicy: 'Delete_IndirectLink_Conf_SharingPolicy',
    DeleteIndirectLinkConfVentilation: 'Delete_IndirectLink_Conf_Ventilation',
    DeleteIndirectLinkConfWeekschedule: 'Delete_IndirectLink_Conf_Weekschedule',
    DeleteIndirectLinkConfWeekscheduleState: 'Delete_IndirectLink_Conf_WeekscheduleState',
    DeleteIndirectLinkDevice: 'Delete_IndirectLink_Device',
    DeleteIndirectLinkDeviceAnalytics: 'Delete_IndirectLink_DeviceAnalytics',
    DeleteIndirectLinkFirmware: 'Delete_IndirectLink_Firmware',
    DeleteIndirectLinkHistory: 'Delete_IndirectLink_History',
    DeleteIndirectLinkManufacturing: 'Delete_IndirectLink_Manufacturing',
    DeleteIndirectLinkMetrics: 'Delete_IndirectLink_Metrics',
    DeleteIndirectLinkRoles: 'Delete_IndirectLink_Roles',
    DeleteIndirectLinkSystem: 'Delete_IndirectLink_System',
    DeleteIndirectLinkTranslation: 'Delete_IndirectLink_Translation',
    DeleteIndirectLinkUser: 'Delete_IndirectLink_User',
    GetAnyResourceAccount: 'Get_AnyResource_Account',
    GetAnyResourceAdministration: 'Get_AnyResource_Administration',
    GetAnyResourceConfAmbientOffset: 'Get_AnyResource_Conf_AmbientOffset',
    GetAnyResourceConfBoilerControlMode: 'Get_AnyResource_Conf_BoilerControlMode',
    GetAnyResourceConfClimateMode: 'Get_AnyResource_Conf_ClimateMode',
    GetAnyResourceConfDeviceInfo: 'Get_AnyResource_Conf_DeviceInfo',
    GetAnyResourceConfDeviceReset: 'Get_AnyResource_Conf_DeviceReset',
    GetAnyResourceConfDhwBoost: 'Get_AnyResource_Conf_DhwBoost',
    GetAnyResourceConfDhwPreferences: 'Get_AnyResource_Conf_DhwPreferences',
    GetAnyResourceConfDisplayBrightness: 'Get_AnyResource_Conf_DisplayBrightness',
    GetAnyResourceConfFilterState: 'Get_AnyResource_Conf_FilterState',
    GetAnyResourceConfFlameState: 'Get_AnyResource_Conf_FlameState',
    GetAnyResourceConfHeatPumpSetup: 'Get_AnyResource_Conf_HeatPumpSetup',
    GetAnyResourceConfLegionella: 'Get_AnyResource_Conf_Legionella',
    GetAnyResourceConfPreheatSetpoint: 'Get_AnyResource_Conf_PreheatSetpoint',
    GetAnyResourceConfRemoteLogging: 'Get_AnyResource_Conf_RemoteLogging',
    GetAnyResourceConfRoomSetpoint: 'Get_AnyResource_Conf_RoomSetpoint',
    GetAnyResourceConfSettings: 'Get_AnyResource_Conf_Settings',
    GetAnyResourceConfSharingPolicy: 'Get_AnyResource_Conf_SharingPolicy',
    GetAnyResourceConfVentilation: 'Get_AnyResource_Conf_Ventilation',
    GetAnyResourceConfWeekschedule: 'Get_AnyResource_Conf_Weekschedule',
    GetAnyResourceConfWeekscheduleState: 'Get_AnyResource_Conf_WeekscheduleState',
    GetAnyResourceDevice: 'Get_AnyResource_Device',
    GetAnyResourceDeviceAnalytics: 'Get_AnyResource_DeviceAnalytics',
    GetAnyResourceFirmware: 'Get_AnyResource_Firmware',
    GetAnyResourceHistory: 'Get_AnyResource_History',
    GetAnyResourceManufacturing: 'Get_AnyResource_Manufacturing',
    GetAnyResourceMetrics: 'Get_AnyResource_Metrics',
    GetAnyResourceRoles: 'Get_AnyResource_Roles',
    GetAnyResourceSystem: 'Get_AnyResource_System',
    GetAnyResourceTranslation: 'Get_AnyResource_Translation',
    GetAnyResourceUser: 'Get_AnyResource_User',
    GetDirectLinkAccount: 'Get_DirectLink_Account',
    GetDirectLinkAdministration: 'Get_DirectLink_Administration',
    GetDirectLinkConfAmbientOffset: 'Get_DirectLink_Conf_AmbientOffset',
    GetDirectLinkConfBoilerControlMode: 'Get_DirectLink_Conf_BoilerControlMode',
    GetDirectLinkConfClimateMode: 'Get_DirectLink_Conf_ClimateMode',
    GetDirectLinkConfDeviceInfo: 'Get_DirectLink_Conf_DeviceInfo',
    GetDirectLinkConfDeviceReset: 'Get_DirectLink_Conf_DeviceReset',
    GetDirectLinkConfDhwBoost: 'Get_DirectLink_Conf_DhwBoost',
    GetDirectLinkConfDhwPreferences: 'Get_DirectLink_Conf_DhwPreferences',
    GetDirectLinkConfDisplayBrightness: 'Get_DirectLink_Conf_DisplayBrightness',
    GetDirectLinkConfFilterState: 'Get_DirectLink_Conf_FilterState',
    GetDirectLinkConfFlameState: 'Get_DirectLink_Conf_FlameState',
    GetDirectLinkConfHeatPumpSetup: 'Get_DirectLink_Conf_HeatPumpSetup',
    GetDirectLinkConfLegionella: 'Get_DirectLink_Conf_Legionella',
    GetDirectLinkConfPreheatSetpoint: 'Get_DirectLink_Conf_PreheatSetpoint',
    GetDirectLinkConfRemoteLogging: 'Get_DirectLink_Conf_RemoteLogging',
    GetDirectLinkConfRoomSetpoint: 'Get_DirectLink_Conf_RoomSetpoint',
    GetDirectLinkConfSettings: 'Get_DirectLink_Conf_Settings',
    GetDirectLinkConfSharingPolicy: 'Get_DirectLink_Conf_SharingPolicy',
    GetDirectLinkConfVentilation: 'Get_DirectLink_Conf_Ventilation',
    GetDirectLinkConfWeekschedule: 'Get_DirectLink_Conf_Weekschedule',
    GetDirectLinkConfWeekscheduleState: 'Get_DirectLink_Conf_WeekscheduleState',
    GetDirectLinkDevice: 'Get_DirectLink_Device',
    GetDirectLinkDeviceAnalytics: 'Get_DirectLink_DeviceAnalytics',
    GetDirectLinkFirmware: 'Get_DirectLink_Firmware',
    GetDirectLinkHistory: 'Get_DirectLink_History',
    GetDirectLinkManufacturing: 'Get_DirectLink_Manufacturing',
    GetDirectLinkMetrics: 'Get_DirectLink_Metrics',
    GetDirectLinkRoles: 'Get_DirectLink_Roles',
    GetDirectLinkSystem: 'Get_DirectLink_System',
    GetDirectLinkTranslation: 'Get_DirectLink_Translation',
    GetDirectLinkUser: 'Get_DirectLink_User',
    GetIndirectLinkAccount: 'Get_IndirectLink_Account',
    GetIndirectLinkAdministration: 'Get_IndirectLink_Administration',
    GetIndirectLinkConfAmbientOffset: 'Get_IndirectLink_Conf_AmbientOffset',
    GetIndirectLinkConfBoilerControlMode: 'Get_IndirectLink_Conf_BoilerControlMode',
    GetIndirectLinkConfClimateMode: 'Get_IndirectLink_Conf_ClimateMode',
    GetIndirectLinkConfDeviceInfo: 'Get_IndirectLink_Conf_DeviceInfo',
    GetIndirectLinkConfDeviceReset: 'Get_IndirectLink_Conf_DeviceReset',
    GetIndirectLinkConfDhwBoost: 'Get_IndirectLink_Conf_DhwBoost',
    GetIndirectLinkConfDhwPreferences: 'Get_IndirectLink_Conf_DhwPreferences',
    GetIndirectLinkConfDisplayBrightness: 'Get_IndirectLink_Conf_DisplayBrightness',
    GetIndirectLinkConfFilterState: 'Get_IndirectLink_Conf_FilterState',
    GetIndirectLinkConfFlameState: 'Get_IndirectLink_Conf_FlameState',
    GetIndirectLinkConfHeatPumpSetup: 'Get_IndirectLink_Conf_HeatPumpSetup',
    GetIndirectLinkConfLegionella: 'Get_IndirectLink_Conf_Legionella',
    GetIndirectLinkConfPreheatSetpoint: 'Get_IndirectLink_Conf_PreheatSetpoint',
    GetIndirectLinkConfRemoteLogging: 'Get_IndirectLink_Conf_RemoteLogging',
    GetIndirectLinkConfRoomSetpoint: 'Get_IndirectLink_Conf_RoomSetpoint',
    GetIndirectLinkConfSettings: 'Get_IndirectLink_Conf_Settings',
    GetIndirectLinkConfSharingPolicy: 'Get_IndirectLink_Conf_SharingPolicy',
    GetIndirectLinkConfVentilation: 'Get_IndirectLink_Conf_Ventilation',
    GetIndirectLinkConfWeekschedule: 'Get_IndirectLink_Conf_Weekschedule',
    GetIndirectLinkConfWeekscheduleState: 'Get_IndirectLink_Conf_WeekscheduleState',
    GetIndirectLinkDevice: 'Get_IndirectLink_Device',
    GetIndirectLinkDeviceAnalytics: 'Get_IndirectLink_DeviceAnalytics',
    GetIndirectLinkFirmware: 'Get_IndirectLink_Firmware',
    GetIndirectLinkHistory: 'Get_IndirectLink_History',
    GetIndirectLinkManufacturing: 'Get_IndirectLink_Manufacturing',
    GetIndirectLinkMetrics: 'Get_IndirectLink_Metrics',
    GetIndirectLinkRoles: 'Get_IndirectLink_Roles',
    GetIndirectLinkSystem: 'Get_IndirectLink_System',
    GetIndirectLinkTranslation: 'Get_IndirectLink_Translation',
    GetIndirectLinkUser: 'Get_IndirectLink_User',
    SetAnyResourceAccount: 'Set_AnyResource_Account',
    SetAnyResourceAdministration: 'Set_AnyResource_Administration',
    SetAnyResourceConfAmbientOffset: 'Set_AnyResource_Conf_AmbientOffset',
    SetAnyResourceConfBoilerControlMode: 'Set_AnyResource_Conf_BoilerControlMode',
    SetAnyResourceConfClimateMode: 'Set_AnyResource_Conf_ClimateMode',
    SetAnyResourceConfDeviceInfo: 'Set_AnyResource_Conf_DeviceInfo',
    SetAnyResourceConfDeviceReset: 'Set_AnyResource_Conf_DeviceReset',
    SetAnyResourceConfDhwBoost: 'Set_AnyResource_Conf_DhwBoost',
    SetAnyResourceConfDhwPreferences: 'Set_AnyResource_Conf_DhwPreferences',
    SetAnyResourceConfDisplayBrightness: 'Set_AnyResource_Conf_DisplayBrightness',
    SetAnyResourceConfFilterState: 'Set_AnyResource_Conf_FilterState',
    SetAnyResourceConfFlameState: 'Set_AnyResource_Conf_FlameState',
    SetAnyResourceConfHeatPumpSetup: 'Set_AnyResource_Conf_HeatPumpSetup',
    SetAnyResourceConfLegionella: 'Set_AnyResource_Conf_Legionella',
    SetAnyResourceConfPreheatSetpoint: 'Set_AnyResource_Conf_PreheatSetpoint',
    SetAnyResourceConfRemoteLogging: 'Set_AnyResource_Conf_RemoteLogging',
    SetAnyResourceConfRoomSetpoint: 'Set_AnyResource_Conf_RoomSetpoint',
    SetAnyResourceConfSettings: 'Set_AnyResource_Conf_Settings',
    SetAnyResourceConfSharingPolicy: 'Set_AnyResource_Conf_SharingPolicy',
    SetAnyResourceConfVentilation: 'Set_AnyResource_Conf_Ventilation',
    SetAnyResourceConfWeekschedule: 'Set_AnyResource_Conf_Weekschedule',
    SetAnyResourceConfWeekscheduleState: 'Set_AnyResource_Conf_WeekscheduleState',
    SetAnyResourceDevice: 'Set_AnyResource_Device',
    SetAnyResourceDeviceAnalytics: 'Set_AnyResource_DeviceAnalytics',
    SetAnyResourceFirmware: 'Set_AnyResource_Firmware',
    SetAnyResourceHistory: 'Set_AnyResource_History',
    SetAnyResourceManufacturing: 'Set_AnyResource_Manufacturing',
    SetAnyResourceMetrics: 'Set_AnyResource_Metrics',
    SetAnyResourceRoles: 'Set_AnyResource_Roles',
    SetAnyResourceSystem: 'Set_AnyResource_System',
    SetAnyResourceTranslation: 'Set_AnyResource_Translation',
    SetAnyResourceUser: 'Set_AnyResource_User',
    SetDirectLinkAccount: 'Set_DirectLink_Account',
    SetDirectLinkAdministration: 'Set_DirectLink_Administration',
    SetDirectLinkConfAmbientOffset: 'Set_DirectLink_Conf_AmbientOffset',
    SetDirectLinkConfBoilerControlMode: 'Set_DirectLink_Conf_BoilerControlMode',
    SetDirectLinkConfClimateMode: 'Set_DirectLink_Conf_ClimateMode',
    SetDirectLinkConfDeviceInfo: 'Set_DirectLink_Conf_DeviceInfo',
    SetDirectLinkConfDeviceReset: 'Set_DirectLink_Conf_DeviceReset',
    SetDirectLinkConfDhwBoost: 'Set_DirectLink_Conf_DhwBoost',
    SetDirectLinkConfDhwPreferences: 'Set_DirectLink_Conf_DhwPreferences',
    SetDirectLinkConfDisplayBrightness: 'Set_DirectLink_Conf_DisplayBrightness',
    SetDirectLinkConfFilterState: 'Set_DirectLink_Conf_FilterState',
    SetDirectLinkConfFlameState: 'Set_DirectLink_Conf_FlameState',
    SetDirectLinkConfHeatPumpSetup: 'Set_DirectLink_Conf_HeatPumpSetup',
    SetDirectLinkConfLegionella: 'Set_DirectLink_Conf_Legionella',
    SetDirectLinkConfPreheatSetpoint: 'Set_DirectLink_Conf_PreheatSetpoint',
    SetDirectLinkConfRemoteLogging: 'Set_DirectLink_Conf_RemoteLogging',
    SetDirectLinkConfRoomSetpoint: 'Set_DirectLink_Conf_RoomSetpoint',
    SetDirectLinkConfSettings: 'Set_DirectLink_Conf_Settings',
    SetDirectLinkConfSharingPolicy: 'Set_DirectLink_Conf_SharingPolicy',
    SetDirectLinkConfVentilation: 'Set_DirectLink_Conf_Ventilation',
    SetDirectLinkConfWeekschedule: 'Set_DirectLink_Conf_Weekschedule',
    SetDirectLinkConfWeekscheduleState: 'Set_DirectLink_Conf_WeekscheduleState',
    SetDirectLinkDevice: 'Set_DirectLink_Device',
    SetDirectLinkDeviceAnalytics: 'Set_DirectLink_DeviceAnalytics',
    SetDirectLinkFirmware: 'Set_DirectLink_Firmware',
    SetDirectLinkHistory: 'Set_DirectLink_History',
    SetDirectLinkManufacturing: 'Set_DirectLink_Manufacturing',
    SetDirectLinkMetrics: 'Set_DirectLink_Metrics',
    SetDirectLinkRoles: 'Set_DirectLink_Roles',
    SetDirectLinkSystem: 'Set_DirectLink_System',
    SetDirectLinkTranslation: 'Set_DirectLink_Translation',
    SetDirectLinkUser: 'Set_DirectLink_User',
    SetIndirectLinkAccount: 'Set_IndirectLink_Account',
    SetIndirectLinkAdministration: 'Set_IndirectLink_Administration',
    SetIndirectLinkConfAmbientOffset: 'Set_IndirectLink_Conf_AmbientOffset',
    SetIndirectLinkConfBoilerControlMode: 'Set_IndirectLink_Conf_BoilerControlMode',
    SetIndirectLinkConfClimateMode: 'Set_IndirectLink_Conf_ClimateMode',
    SetIndirectLinkConfDeviceInfo: 'Set_IndirectLink_Conf_DeviceInfo',
    SetIndirectLinkConfDeviceReset: 'Set_IndirectLink_Conf_DeviceReset',
    SetIndirectLinkConfDhwBoost: 'Set_IndirectLink_Conf_DhwBoost',
    SetIndirectLinkConfDhwPreferences: 'Set_IndirectLink_Conf_DhwPreferences',
    SetIndirectLinkConfDisplayBrightness: 'Set_IndirectLink_Conf_DisplayBrightness',
    SetIndirectLinkConfFilterState: 'Set_IndirectLink_Conf_FilterState',
    SetIndirectLinkConfFlameState: 'Set_IndirectLink_Conf_FlameState',
    SetIndirectLinkConfHeatPumpSetup: 'Set_IndirectLink_Conf_HeatPumpSetup',
    SetIndirectLinkConfLegionella: 'Set_IndirectLink_Conf_Legionella',
    SetIndirectLinkConfPreheatSetpoint: 'Set_IndirectLink_Conf_PreheatSetpoint',
    SetIndirectLinkConfRemoteLogging: 'Set_IndirectLink_Conf_RemoteLogging',
    SetIndirectLinkConfRoomSetpoint: 'Set_IndirectLink_Conf_RoomSetpoint',
    SetIndirectLinkConfSettings: 'Set_IndirectLink_Conf_Settings',
    SetIndirectLinkConfSharingPolicy: 'Set_IndirectLink_Conf_SharingPolicy',
    SetIndirectLinkConfVentilation: 'Set_IndirectLink_Conf_Ventilation',
    SetIndirectLinkConfWeekschedule: 'Set_IndirectLink_Conf_Weekschedule',
    SetIndirectLinkConfWeekscheduleState: 'Set_IndirectLink_Conf_WeekscheduleState',
    SetIndirectLinkDevice: 'Set_IndirectLink_Device',
    SetIndirectLinkDeviceAnalytics: 'Set_IndirectLink_DeviceAnalytics',
    SetIndirectLinkFirmware: 'Set_IndirectLink_Firmware',
    SetIndirectLinkHistory: 'Set_IndirectLink_History',
    SetIndirectLinkManufacturing: 'Set_IndirectLink_Manufacturing',
    SetIndirectLinkMetrics: 'Set_IndirectLink_Metrics',
    SetIndirectLinkRoles: 'Set_IndirectLink_Roles',
    SetIndirectLinkSystem: 'Set_IndirectLink_System',
    SetIndirectLinkTranslation: 'Set_IndirectLink_Translation',
    SetIndirectLinkUser: 'Set_IndirectLink_User'
} as const;
export type Permission = typeof Permission[keyof typeof Permission];


export function instanceOfPermission(value: any): boolean {
    for (const key in Permission) {
        if (Object.prototype.hasOwnProperty.call(Permission, key)) {
            if (Permission[key as keyof typeof Permission] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PermissionFromJSON(json: any): Permission {
    return PermissionFromJSONTyped(json, false);
}

export function PermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Permission {
    return json as Permission;
}

export function PermissionToJSON(value?: Permission | null): any {
    return value as any;
}

export function PermissionToJSONTyped(value: any, ignoreDiscriminator: boolean): Permission {
    return value as Permission;
}

